import React, { useState, useEffect } from 'react';
import { auth, db, storage } from '../../utils/firebase';
import { doc, updateDoc, arrayUnion, arrayRemove, getDoc, setDoc } from 'firebase/firestore';
import { getDownloadURL, ref } from 'firebase/storage';
import HoverCard from './HoverCard.js';
import './RecreationalActivities.css';

const RecreationalActivities = () => {
  const [user, setUser] = useState(null);
  const [favorites, setFavorites] = useState({});
  const [strikeGymImage, setStrikeGymImage] = useState(null); // State for the image URL
  const [sensyongsMuseumImage, setsensyongsMuseumImage] = useState(null); 
  const [bacoorEcoparkImage, setbacoorEcoparkImage] = useState(null); 
  const [somoImage, setsomoImage] = useState(null); 
  const [rfcImage, setrfcImage] = useState(null); 
  const [msquareImage, setmsquareImage] = useState(null); 

  useEffect(() => {
    // Listen for user authentication changes
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        fetchFavorites(currentUser.uid);
      }
    });

    // Fetch the Strike Gym image from Firebase Storage
    fetchImage('things/5fx5mCQqyFrEvyobUiTYR.jpg', setStrikeGymImage);
    fetchImage('things/5zporfYN4AVpqOZflcdXR.jpg', setsensyongsMuseumImage);
    fetchImage('things/5m6NwWuJgpORATgllDX6F.jpg', setbacoorEcoparkImage);
    fetchImage('things/5WFNI0cNNuPGi7KX7J9Z7.jpg', setsomoImage);
    fetchImage('things/5NkEFI7SzNoPaTZSE6smT.jpg', setrfcImage);
    fetchImage('things/2JgJRrcxxRvQThzZI0CRX.jpg', setmsquareImage);

    return unsubscribe;
  }, []);

  const fetchFavorites = async (userId) => {
    const userDocRef = doc(db, 'Users', userId);
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      setFavorites(userDoc.data().favorites || {});
    } else {
      await setDoc(userDocRef, { favorites: {} });
      setFavorites({});
    }
  };

  const fetchImage = async (path, setImageCallback) => {
    try {
      const imageRef = ref(storage, path);
      const url = await getDownloadURL(imageRef);
      setImageCallback(url);
    } catch (error) {
      console.error('Error fetching image:', error);
    }
  };

  const toggleFavorite = async (event, itemTitle) => {
    event.stopPropagation(); // Prevent card click
    if (!user) return;

    const userDocRef = doc(db, 'Users', user.uid);
    const updatedFavorites = { ...favorites };

    const isFavorited = updatedFavorites['Shopping and Markets']?.includes(itemTitle);

    if (isFavorited) {
      updatedFavorites['Shopping and Markets'] = updatedFavorites['Shopping and Markets'].filter(
        (name) => name !== itemTitle
      );
      await updateDoc(userDocRef, { [`favorites.Shopping and Markets`]: arrayRemove(itemTitle) });
    } else {
      updatedFavorites['Shopping and Markets'] = [
        ...(updatedFavorites['Shopping and Markets'] || []),
        itemTitle,
      ];
      await updateDoc(userDocRef, { [`favorites.Shopping and Markets`]: arrayUnion(itemTitle) });
    }

    setFavorites(updatedFavorites);
  };

  return (
    <div className="cultural-experiences">
      <h1 className="main-title">Shopping and Markets</h1>
      <p className="description">
      Discover the vibrant shopping destinations in Bacoor, from bustling public markets to popular shopping malls.
      </p>
      <div className="card-container">
        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="SM City Bacoor"
            imageUrl={strikeGymImage || 'placeholder-image.jpg'} 
            linkTo="/smbacoor"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Shopping and Markets']?.includes('SM City Bacoor')
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, 'SM City Bacoor')
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Shopping and Markets']?.includes('SM City Bacoor')
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="NOMO"
            imageUrl={sensyongsMuseumImage || 'placeholder-image.jpg'} 
            linkTo="/nomo"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Shopping and Markets']?.includes("NOMO")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "NOMO")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Shopping and Markets']?.includes("NOMO")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="SM City Molino"
            imageUrl={bacoorEcoparkImage || 'placeholder-image.jpg'} 
            linkTo="/smmolino"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Shopping and Markets']?.includes("SM City Molino")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "SM City Molino")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Shopping and Markets']?.includes("SM City Molino")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="SOMO Market"
            imageUrl={somoImage || 'placeholder-image.jpg'} 
            linkTo="/somo"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Shopping and Markets']?.includes("SOMO Market")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "SOMO Market")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Shopping and Markets']?.includes("SOMO Market")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="RFC Molino Mall"
            imageUrl={rfcImage || 'placeholder-image.jpg'} 
            linkTo="/rfcmall"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Shopping and Markets']?.includes("RFC Molino Mall")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "RFC Molino Mall")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Shopping and Markets']?.includes("RFC Molino Mall")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>


        <div className="hover-card-wrapper position-relative">
          <HoverCard
            title="Main Square Bacoor"
            imageUrl={msquareImage || 'placeholder-image.jpg'} 
            linkTo="/mainsquare"
          />
          {user && (
            <button
              className={`btn btn-light position-absolute top-0 end-0 m-2 p-1 rounded-circle shadow ${
                favorites['Shopping and Markets']?.includes("Main Square Bacoor")
                  ? 'text-danger'
                  : ''
              }`}
              onClick={(event) =>
                toggleFavorite(event, "Main Square Bacoor")
              }
            >
              <i
                className={`bi bi-heart${
                  favorites['Shopping and Markets']?.includes("Main Square Bacoor")
                    ? '-fill'
                    : ''
                }`}
              ></i>
            </button>
          )}
        </div>

      </div>
    </div>
  );
};

export default RecreationalActivities;
